import { useCallback, useMemo } from 'react';

import { useFeatureFlagsQuery } from 'graphql/generated/graphql';

import useGraphaelDefaults from 'hooks/useGraphaelDefaults';

export enum FeatureFlag {
  UNLOCK_ALL_AUDIOS = 'UNLOCK_ALL_AUDIOS',
  SAC_ENABLED = 'SAC_ENABLED',
}

export const useFeatureFlags = () => {
  const { data } = useFeatureFlagsQuery(useGraphaelDefaults());

  const flags = useMemo(() => {
    if (!data?.featureFlags) {
      return {};
    }

    return data.featureFlags.reduce((acc, flag) => {
      acc[flag.featureName] = flag.enabled;

      return acc;
    }, {});
  }, [data]);

  const isFeatureFlagEnabled = useCallback(
    (featureName: FeatureFlag) => !!flags[featureName],
    [flags],
  );

  return {
    isFeatureFlagEnabled,
  };
};
